import axios from "axios";

export default {
  cekToken,
  getHakAkses,
  isWrite,
  isRead,
  getStorageNameArray,
};

/**
 * Parse localStorage yang disimpan sebagai JSON array
 * (dipakai untuk menu_write_names / menu_read_names dari role_cermat).
 */
function getStorageNameArray(key) {
  const value = localStorage.getItem(key);

  if (!value) {
    return [];
  }

  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
}

async function cekToken() {
  return await axios({
    method: "get",
    url: process.env.VUE_APP_BACKEND_URL_VERSION + "auth/check-token",
    headers: {
      Authorization: `Bearer ${localStorage.access_token}`,
    },
  })
    .then((response) => response)
    .catch((err) => {
      console.log("err check token:", err);
      return false;
    });
}

export async function getHakAkses(menu) {
  const data = await axios({
    method: "get",
    url: process.env.VUE_APP_BACKEND_URL_VERSION + "auth/get-hak-akses",
    params: {
      menu: menu,
      role: localStorage.getItem("role_cermat"),
    },
    headers: {
      Authorization: `Bearer ${localStorage.access_token}`,
      Accept: "Application/json",
    },
  })
    .then((response) => response.data.data)
    .catch((err) => {
      console.log("err get hak akses", err);
      return false;
    });
  if (data) {
    console.log("data hak akses", data);
    return data;
  }
  return { is_read: false, is_write: false };
}

/**
 * Cek hak akses write untuk sebuah menu berdasarkan label,
 * mengacu pada menuWrite dari response role_cermat (disimpan saat login
 * sebagai "menu_write_names").
 */
export function isWrite(menuLabel) {
  const menuWriteNames = getStorageNameArray("menu_write_names");
  return menuWriteNames.includes(menuLabel);
}

/**
 * Cek hak akses read untuk sebuah menu berdasarkan label,
 * mengacu pada menuRead dari response role_cermat (disimpan saat login
 * sebagai "menu_read_names"). Menu yang boleh ditulis otomatis boleh dibaca.
 */
export function isRead(menuLabel) {
  const menuReadNames = getStorageNameArray("menu_read_names");
  return menuReadNames.includes(menuLabel) || isWrite(menuLabel);
}
